export type Preferences = {
	regions: string[];
	askingPrice: number;
};

type ReadonlyPreferences = Readonly<
	Omit<Preferences, 'regions'> & {
		readonly regions: readonly string[];
	}
>;

interface UsePreferencesCookieReturn {
	getPreferences: () => ReadonlyPreferences;
	setPreferences: (preferences: Preferences) => void;
}

export function usePreferencesCookie(): UsePreferencesCookieReturn {
	const maxAge = 60 * 60 * 24 * 30;
	const preferencesCookie = useCookie<Preferences>('preferences', {
		maxAge,
		sameSite: true,
		expires: new Date(Date.now() + maxAge * 1000)
	});

	const readonlyPreferences = readonly(preferencesCookie.value || {});

	function getPreferences() {
		return readonlyPreferences;
	}

	function setPreferences(preferences: Preferences) {
		preferencesCookie.value = {
			...preferences
		};
	}

	return {
		getPreferences,
		setPreferences
	};
}
